import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Add as AddIcon,
  ListAlt as ListAltIcon,
  PostAdd as PostAddIcon,
  CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import {
  canCreateCounterparty,
  canUseOnboardingRequests
} from "../../../../auth/permissions";
import { useRoles } from "../../../../auth/useRoles";

type Props = {};

export const CounterpartiesMenu: FC<Props> = () => {
  const roles = useRoles();
  const location = useLocation();
  const showCreateCounterparty = canCreateCounterparty(roles);
  const showOnboardingRequests = canUseOnboardingRequests(roles);
  const isCompletedPage = location.pathname.startsWith(
    "/tradingcounterparties/completed"
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
        <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
          {isCompletedPage
            ? "Onboarded Trading Counterparties"
            : "Trading Counterparties"}
        </Typography>
      </Box>
      <Box display="flex" gap={1}>
        {!isCompletedPage && (
          <Link to="/tradingcounterparties/completed">
            <Button
              variant="outlined"
              startIcon={<CheckCircleIcon color="success" />}
            >
              Completed
            </Button>
          </Link>
        )}
        {showOnboardingRequests && !isCompletedPage && (
          <>
            <Link to="/tradingcounterparties/request-new">
              <Button variant="outlined" startIcon={<PostAddIcon />}>
                Request
              </Button>
            </Link>
            <Link to="/tradingcounterparties/my-requests">
              <Button variant="outlined" startIcon={<ListAltIcon />}>
                My requests
              </Button>
            </Link>
          </>
        )}
        {showCreateCounterparty && !isCompletedPage && (
          <Link to="/tradingcounterparties/new">
            <Button variant="contained" startIcon={<AddIcon />}>
              Onboard new TC
            </Button>
          </Link>
        )}
      </Box>
    </Box>
  );
};
